import React from 'react';

const SpHeaterBar = (props) => {
  const userId = props.user._id;
  let indicator = 0

  if(props.spHeaterType === "Wood Stove" || props.spHeaterType === "Pellet Stove"|| props.spHeaterType === "Oil Furnace" || props.spHeaterType === "Electric Resistance" || props.spHeaterType === "Central Gas Furnace" && props.spHeaterAge > 15|| props.spHeaterType === "Room Gas Furnace" && props.spHeaterAge > 15 || props.spHeaterType === "Gas Boiler/Radiant" && props.spHeaterAge > 15 || props.spHeaterType === "Electric Heat Pump" && props.spHeaterAge > 15 || props.spHeaterType === "Geothermal Heat Pump" && props.spHeaterAge > 15 || props.spHeaterType === "Electric Mini-Split" && props.spHeaterAge > 15){
      indicator = 25/2
  }else if(props.spHeaterType === "Central Gas Furnace" && props.spHeaterAge <= 15|| props.spHeaterType === "Room Gas Furnace" && props.spHeaterAge <= 15 || props.spHeaterType === "Gas Boiler/Radiant" && props.spHeaterAge <= 15){
      indicator = 25 + 25/2
  }else if(props.spHeaterType === "Electric Heat Pump" && props.spHeaterAge <= 15 || props.spHeaterType === "Geothermal Heat Pump" && props.spHeaterAge <= 15){
      indicator = 50 + 25/2
  }else if(props.spHeaterType === "Electric Mini-Split" && props.spHeaterAge <= 15){
      indicator = 75 + 25/2
  }

  return(
    <div className="spHeaterBar">
      <div className="analysisTitle">Space Heater</div>
      <div className="indicator" style={{marginLeft: `${indicator}%`}}><img src="../../SVG/new_indicator.svg"/></div>
      <div className="barContainer">
        <div className="red_level"><div className="barText">Old Technology</div></div>
        <div className="orange_level"><div className="barText">Gas Baseline</div></div>
        <div className="yellow_level"><div className="barText">Better</div></div>
        <div className="green_level"><div className="barText">Best</div></div>
      </div>
      <div className="inches">
        <div className="redIn h5">Near Burnout Age or Other Type</div>
        <div className="orangeIn h5">Gas Furnace</div>
        <div className="yellowIn h5">Electric Heat Pump</div>
        <div className="greenIn h5">Electric Mini-Split Heat Pump</div>
      </div>
      <div>Your space heater is a {props.spHeaterType} with an age of {props.spHeaterAge}. It should be replaced when it exceeds its 15-year expected life. A ducted or ductless heat pump is an attractive technology. Heat pumps are more than 3x more efficient than gas, and can be powered with a renewable energy source such as rooftop solar.</div>
    </div>
  )
}
export default SpHeaterBar
